/**
 * The app-local consent cookie that predates the shared `rio_consent` cookie.
 * Its only remaining reader is the one-time migration in
 * `@/lib/consent/consent-cookie` — nothing writes it any more.
 */
export const COOKIE_CONSENT_KEY = 'rio_cookie_consent';
